import { Switch } from "@/components/ui/switch";
import { IMAGE_SLOTS, humanize } from "@/lib/design";
import { strings } from "@/i18n/strings";

const IMG_LABEL = Object.fromEntries(IMAGE_SLOTS.map(([k, l]) => [k, l]));
const hiddenLabel = (k, text) => {
  if (k.startsWith("t:")) {
    const key = k.slice(2);
    const v = text?.en?.[key] || strings.en[key] || key;
    return `Text: “${v.length > 60 ? `${v.slice(0, 60)}…` : v}”`;
  }
  if (k.startsWith("img:")) return `Photo: ${IMG_LABEL[k.slice(4)] || k.slice(4)}`;
  return `Block: ${humanize(k.slice(2))}`;
};

const Removed = ({ hidden = {}, text, onPatch }) => {
  const keys = Object.keys(hidden).filter((k) => hidden[k]);
  return (
    <div data-testid="ve-removed-list">
      <p className="mb-1 font-ui text-[11px] uppercase tracking-widest text-[#8A6A12]">Removed items</p>
      {!keys.length && <p className="text-xs text-[#4A5568]">Nothing removed. Use “Select & remove” at the top to remove any block, text or photo.</p>}
      <div className="grid gap-2">
        {keys.map((k, i) => (
          <div key={k} data-testid={`ve-removed-${i}`} className="flex items-center gap-2 rounded-xl border border-[#14213D]/10 bg-white px-3 py-2">
            <span className="min-w-0 flex-1 truncate font-ui text-xs text-[#14213D]">{hiddenLabel(k, text)}</span>
            <button type="button" data-testid={`ve-removed-restore-${i}`} onClick={() => onPatch({ hidden: { [k]: "" } })} className="rounded-full border border-[#14213D]/20 px-3 py-1 font-ui text-[11px] font-semibold text-[#14213D] hover:bg-[#14213D]/5">Show again</button>
          </div>
        ))}
      </div>
    </div>
  );
};

const PAGES = [["about", "About page"], ["sermons", "Messages page"], ["pastors", "Pastors page"], ["gallery", "Events/Programs page"], ["donate", "Give page"], ["contact", "Contact page"]];

export const SectionsPanel = ({ data, onPatch }) => {
  const on = (k) => data.sections?.[k] !== false;
  return (
    <div className="grid gap-5">
      <Removed hidden={data.hidden} text={data.text} onPatch={onPatch} />
      <p data-testid="ve-home-order-note" className="rounded-xl bg-white p-3 text-xs text-[#4A5568]">To reorder or hide the <b>Home page</b> sections, or add videos, text and photos to it, open Home in the preview and use the <b>This page</b> tab.</p>
      <div>
        <p className="mb-2 font-ui text-[11px] uppercase tracking-widest text-[#8A6A12]">Pages</p>
        {PAGES.map(([k, l]) => (
          <label key={k} className="flex items-center justify-between py-1.5 font-ui text-sm text-[#14213D]">
            {l}
            <Switch data-testid={`ve-page-toggle-${k}`} checked={on(k)} onCheckedChange={(v) => onPatch({ sections: { [k]: v } })} />
          </label>
        ))}
      </div>
    </div>
  );
};
